var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.848,
    height: 24.908,
    viewBox: "0 0 22.848 24.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4746.26 -16141.671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,91.337V88.462a7.284,7.284,0,0,1,7.284-7.284l3.39,3.717,3.39-3.717a7.284,7.284,0,0,1,7.284,7.284v2.875",
    transform: "translate(-4746.51 16075.242)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.929,6.257A5.256,5.256,0,1,1,39.673,1a5.256,5.256,0,0,1,5.256,5.256",
    transform: "translate(-4774.509 16141.42)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.929,6.257A5.256,5.256,0,1,1,39.673,1,5.256,5.256,0,0,1,44.929,6.257Z",
    transform: "translate(-4774.509 16141.42)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.c01dfd93f84787356c78b0435e572d03.svg";
export { ForwardRef as ReactComponent };